import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { ITafAdaptationStatus } from './types';

export const TAF_ADAPTATION_PROCESS_KEY = 'physical_aptitude_test_process';

const getTafAdaptationStatus = async (registrationId: string): Promise<ITafAdaptationStatus> => {
  const response = await configApi.get<ITafAdaptationStatus>(
    `attachment/registration/${registrationId}/step-upload/${TAF_ADAPTATION_PROCESS_KEY}/status/`,
  );
  return response.data;
};

export const useGetTafAdaptationStatus = (registrationId: string, enabled: boolean) => {
  return useQuery({
    queryKey: ['taf_adaptation_status', registrationId],
    queryFn: () => getTafAdaptationStatus(registrationId),
    enabled: enabled && !!registrationId,
    refetchOnWindowFocus: false,
    gcTime: 0,
  });
};
